(function dynamicNumberDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlNumber', [])
        .directive('dynamicNumber', function () {
            return {
                replace: true,
                restrict: 'E',
                controller: [
                     '$scope', function ($scope) {
                    if ($scope.data && $scope.data.metadataValue) {
                        $scope.data.metadataValue = parseFloat($scope.data.metadataValue);
                    }
                     }],

                link: function (scope, iElement, iAttrs) {
                },
                templateUrl: '/app/directives/custom-control-number/custom-control-number-template.html'
            };
        });

    angular.module('CustomControlNumber')
      .directive('dynamicFilterNumber', function () {
          return {
              replace: true,
              require: '^form',
              restrict: 'E',
              controller: [
                      '$scope', function ($scope) {
                          if ($scope.data && (!$scope.data.metadataSearchTypeFrom || !$scope.data.metadataSearchTypeTo)) {
                              $scope.data.metadataSearchTypeFrom = 'GreaterThanOrEqual';
                              $scope.data.metadataSearchTypeTo = 'LessThanOrEqual';
                          }                                               

                      }],
              
              link: function (scope, iElement, iAttrs, formCtrl) {

                  scope.formCtrl = formCtrl;

              },
              templateUrl: '/app/directives/custom-control-number/custom-control-filter-number-template.html'
          };
      });
})();